import { useMemo } from 'react';
import { Select } from '@customerio/pluma-components/react';
import type { ApiCredential } from '@/services/db/api-credential/entity';

const PLACEHOLDER = 'Select credentials';

type CredentialsSelectProps = {
  credentials: readonly ApiCredential[];
  selectedCredentialId: string | null;
  onSelect: (credential: ApiCredential) => void;
  label: string;
};

/**
 * Picks one of the workspace's tracking API credentials.
 *
 * Selection cannot be cleared: the pages that use this always show a credential
 * once one is chosen, so a null value from the field is ignored rather than
 * unsetting the caller's state.
 */
export function CredentialsSelect({ credentials, selectedCredentialId, onSelect, label }: CredentialsSelectProps) {
  const options = useMemo(
    () => credentials.map((credential) => ({ label: credential.name, value: credential.id })),
    [credentials],
  );

  return (
    <Select
      label={label}
      placeholder={PLACEHOLDER}
      options={options}
      value={selectedCredentialId}
      onChange={(value) => {
        const credential = credentials.find((candidate) => candidate.id === value);
        if (credential != null) {
          onSelect(credential);
        }
      }}
    />
  );
}
